import { ApiService } from "../utils/ApiService.js";

export class MuestreosService {
  // Devuelve { muestreos: [...], resumenSucursales: [...], familiasDisponibles: [...] }
  // filtros: { sucursal, desde, hasta, familia }. sucursal puede ser un id numérico o
  // "sin-asignar" (equipos todavía sin sucursal); desde/hasta van como "AAAA-MM-DD".
  static async listar({ sucursal = null, desde = null, hasta = null, familia = null } = {}) {
    const q = new URLSearchParams();
    if (sucursal === "sin-asignar") q.set("sinAsignar", "true");
    else if (sucursal) q.set("sucursal", sucursal);
    if (desde) q.set("desde", desde);
    if (hasta) q.set("hasta", hasta);
    if (familia) q.set("familia", familia);
    const qs = q.toString();
    const data = await ApiService.get("muestreos" + (qs ? "?" + qs : ""), null, { cacheTiempo: "30s" });
    return {
      muestreos: data?.muestreos || [],
      resumenSucursales: data?.resumenSucursales || [],
      familiasDisponibles: data?.familiasDisponibles || [],
    };
  }

  static async borrar(id) {
    await ApiService.del("muestreos/" + encodeURIComponent(id));
    ApiService.invalidate("muestreos");
  }

  static async equipos() {
    const data = await ApiService.get("muestreos/equipos", null, { cacheTiempo: "30s" });
    return Array.isArray(data) ? data : [];
  }

  static async asignarEquipo(deviceId, sucursalId, alias) {
    await ApiService.put("muestreos/equipos/" + encodeURIComponent(deviceId), { SucursalId: sucursalId, Alias: alias });
    // Cambia la resolución de sucursal de los muestreos y la lista de equipos.
    ApiService.invalidate("muestreos");
  }

  static async sucursales() {
    const data = await ApiService.get("sucursales", null, { cacheTiempo: "1h" });
    return Array.isArray(data) ? data : [];
  }
}
